import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Brand from "../pages/brand/page";
import Technology from "../pages/technology/page";
import Community from "../pages/community/page";
import Partnership from "../pages/partnership/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/brand",
    element: <Brand />,
  },
  {
    path: "/technology",
    element: <Technology />,
  },
  {
    path: "/community",
    element: <Community />,
  },
  {
    path: "/partnership",
    element: <Partnership />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;